import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import React from 'react';
import cn from '@/utils/cn';

// AIDEV-NOTE: SPA-scoped Radix Tooltip using tw-spa-* theme tokens — the ui/ TCITooltip bakes the
// light app theme. Label-only content (Radix tooltips aren't keyboard-reachable); fires on hover
// and focus. Composed onto a local wrapper, never Object.assign onto the radix export (see
// SPAPopover for that bug). z-index sits above SPAPopover content (9999) so tooltips work on
// controls inside popovers.
const TooltipContent = React.forwardRef<
React.ElementRef<typeof TooltipPrimitive.Content>,
React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, side = 'top', sideOffset = 6, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      className={cn(
        'tw-z-[10000] tw-rounded tw-border tw-border-solid tw-border-spa-border',
        'tw-bg-spa-bg-secondary tw-px-2 tw-py-1 tw-text-xs tw-text-spa-primary tw-shadow-lg',
      )}
      side={side}
      sideOffset={sideOffset}
      {...props}
    />
  </TooltipPrimitive.Portal>
));

TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const SPATooltipRoot = ({
  delayDuration = 150,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) => (
  <TooltipPrimitive.Provider delayDuration={delayDuration}>
    <TooltipPrimitive.Root {...props} />
  </TooltipPrimitive.Provider>
);

const SPATooltip = Object.assign(SPATooltipRoot, {
  Content: TooltipContent,
  Trigger: TooltipPrimitive.Trigger,
});

export default SPATooltip;
